import React from 'react'
import imageUrl from 'images/search/promotional/bungee-jumping.jpeg'

const BungeeJumpingNode = () => (
  <a
    className="link-unstyled"
    href="/activites/5921-bababox-saut-a-l-elastique">
    <div className="hit-card hit-card-promo">
      <div className="img-container">
        <div className="promo-banner">Promotion</div>
        <img src={imageUrl} alt="Saut à l'élastique" />
      </div>
      <div className="content">
        <div className="promo-title">
          Offrez une Bababox : Saut à l'élastique
        </div>

        <div className="hit-features">
          <div>Offrez une expérience sensationnel riche en émotion.</div>
          <div>Des sauts dans des sites d’exception en France.</div>
          <div>Valide 1 an, renouvelable 12 mois.</div>
        </div>
      </div>
      <div className="hit-card-bottom-container">
        <div className="pricing text-center">
          <span className="price-from">A partir de&nbsp;</span>
          <div className="price">76,50 €&nbsp;</div>
          <span className="price-per">par personne</span>
        </div>
      </div>
    </div>
  </a>
)

export default BungeeJumpingNode
